module.exports = __webpack_public_path__ + "static/media/on-off.f785b900.svg";